import React, {useState} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    children?: React.ReactNode;
    dataTestId?: string;
    preventShowLess?: boolean;
    className?: string;
    dataGtmClick?: string;
    showMoreText?: string;
    showLessText?: string;
    onClick?: () => void;
}

export const ShowMoreButton: React.FunctionComponent<IProps> = (props) => {
    const {preventShowLess, dataGtmClick, showMoreText, showLessText, className, dataTestId} = props;
    const [showContent, setShowContent] = useState<boolean>(false);
    const buttonText = showContent ? (showLessText ? showLessText : "Czytaj mniej") : showMoreText ? showMoreText : "Czytaj więcej";

    const buttonClassName = cx(className, showContent ? overflowAnchorNoneStyle : overflowAnchorAutoStyle, showContent && preventShowLess && hideStyle);

    return (
        <>
            <div className={showContent ? showStyle : hideStyle}>{props.children}</div>

            <Button
                className={buttonClassName}
                variant="highlight_primary"
                onClick={() => setShowContent((prevState) => !prevState)}
                data-gtm-click={dataGtmClick ? dataGtmClick : ""}
                dataTestId={dataTestId}
            >
                <Text variant="button_micro">{buttonText}</Text>
            </Button>
        </>
    );
};

const showStyle = css({
    display: "block"
});

const hideStyle = css({
    display: "none"
});

const overflowAnchorNoneStyle = css({
    overflowAnchor: "none"
});

const overflowAnchorAutoStyle = css({
    overflowAnchor: "auto"
});
